<template>
    <div class="profile-new">
        <div class="container">
            <h4 class="profile-new__title">Tworzenie profilu dziecka</h4>

            <ProfileNewProgress :step="step" class="profile-new__progress"></ProfileNewProgress>

            <div class="profile-new__content">
                <div v-if="step === 1" class="step" data-aos="fade-in">
                    <div class="profile-new__data">
                        <div class="profile-new__data-left">
                            <ProfileNewAvatar 
                                class="profile-new__avatar" 
                                :avatar="avatar"
                                @showAvatarList="showAvatarList">
                            </ProfileNewAvatar>

                            <InputText 
                                class="profile-new__name"
                                :data="profileData.name"
                                :error="errors.name" 
                                @setName="setName">
                            </InputText>
                        </div>

                        <ProfileNewAge 
                            class="profile-new__age" 
                            :ageError="errors.age"
                            :data="profileData.age" 
                            @setAge="setAge">
                        </ProfileNewAge>
                    </div>  

                    <div class="profile-new__pin profile-new__content-row" v-if="profileData.age > 6" data-aos="fade-in">
                        <ProfileNewPin 
                            :pinError="errors.pin"
                            :data="{ isPin: profileData.isPin, pin: profileData.pin }"
                            @savePin="savePin" 
                            @setIsPin="setIsPin">
                        </ProfileNewPin>
                    </div>

                    <!-- <div class="profile-new__content-row profile-new__sound">
                        <InputCheckbox
                            :name="'sound'"
                            :label="'Dźwięk komunikatów głosowych'"
                            :data="profileData.soundPrompts"
                            @setCheckboxValue="setCheckboxValue">
                        </InputCheckbox>
                    </div> -->

                    <!-- <div class="profile-new__content-row">
                        <ProfileNewFacilities
                            class="profile-new__facilities"
                            :fDysfunction="profileData.facilitiesDysfunction"
                            :fOption="profileData.facilitiesOptions"
                            @setFacilities="setFacilities">
                        </ProfileNewFacilities>
                    </div> -->
                </div>

                <div v-if="step === 2" class="step" data-aos="fade-in">
                    <div class="profile-new__content-row">
                        <ProfileNewTimelimit
                            class="profile-new__timelimit" 
                            :data="profileData.timeLimit"
                            :error="errors.timeLimit"
                            @selectTimeLimit="selectTimeLimit">
                        </ProfileNewTimelimit>
                    </div>

                    <div class="profile-new__content-row">
                        <ProfileNewSleephours
                            :data="profileData.sleepHours"
                            :error="errors.sleepHours" 
                            class="profile-new__sleephours" 
                            @selectSleepHours="selectSleepHours">
                        </ProfileNewSleephours>
                    </div>
                </div>

                <div v-if="step === 3" class="step" data-aos="fade-in">
                    <ProfileNewSummary></ProfileNewSummary>
                </div>
            </div>

            <div class="profile-new__nav" v-if="step !== 3">
                <button class="profile-new__nav-btn profile-new__nav-btn--prev" @click="goBack">
                    <IconReturn class="arrow"></IconReturn>
                    <span>Wstecz</span>
                </button>

                <button class="profile-new__nav-btn profile-new__nav-btn--next" @click="goNext">
                    <span>Dalej</span>
                    <IconReturn class="arrow"></IconReturn>
                </button>
            </div>
        </div>

        <ProfileAvatarList v-if="isAvatarList" @closeModal="closeModal" :isChange="true"></ProfileAvatarList>
        <ModalConsent v-if="isModalConsent" @consentHandle="consentHandle"></ModalConsent>
        <LoginPIN v-if="isModalPin" @modalPinToggle="modalPinToggle"></LoginPIN>
    </div>
</template>

<script>
import axios from "axios";
import ProfileAvatarList from "./ProfileAvatarList.vue";
import ProfileNewProgress from "./ProfileNewProgress.vue";
import ProfileNewAvatar from "./ProfileNewAvatar.vue";
import ProfileNewAge from "./ProfileNewAge";
import ProfileNewPin from "./ProfileNewPin";
import ProfileNewTimelimit from "./ProfileNewTimelimit";
import ProfileNewSleephours from "./ProfileNewSleephours";
// import ProfileNewFacilities from "./ProfileNewFacilities";
import ProfileNewSummary from "./ProfileNewSummary";
import InputText from "./InputText";
// import InputCheckbox from "./InputCheckbox";
import IconReturn from "../elements/icons/IconReturn.vue";
import globalDataLayer from '../../mixins/globalDataLayer';
import ModalConsent from "../modals/ModalConsent.vue";
import LoginPIN from "../login/LoginPIN.vue";
import { useToast } from "vue-toastification";

const toast = useToast()

export default {
    name: "ProfileNew",
    components: {
        ProfileAvatarList,
        ProfileNewProgress,
        ProfileNewAvatar,
        ProfileNewAge,
        ProfileNewPin,
        ProfileNewSummary,
        ProfileNewTimelimit,
        // ProfileNewFacilities,
        ProfileNewSleephours,
        InputText,
        // InputCheckbox,
        IconReturn,
        ModalConsent,
        LoginPIN
    },
    data() {
        return {
            ADD_SUBPROFILE: '/api/krainaabc/subprofile/add?device=www',
            CONSENT_ALLOW: '/api/krainaabc/account/user-application-data/consent-allow?device=www',
            isAvatarList: false,
            errors: {
                name: false,
                age: false,
                pin: false,
                timeLimit: false,
                sleepHours: false
            },
            profileData: {
                name: '',
                age: 0,
                isPin: 'no',
                pin: null,
                soundPrompts: false,
                // facilitiesDysfunction: 'no',
                // facilitiesOptions: {
                //     audiodescription: false,
                //     autoSubtitling: false,
                //     signLanguage: false
                // },
                timeLimit: -1,
                sleepHours: [8, 19]
            },
            isModalConsent: false,
            isModalPin: false
        };
    },
    mixins: [globalDataLayer],
    watch: {
        step(value) {
            if(value === 3) {
                this.resetData();
            }
        },
    },
    computed: {
        step() {
            return this.$store.getters.getNewProfileStep;
        },
        avatar() {
            return this.$store.getters.getSelectedAvatar;
        },
        subProfileslist() {
            return this.$store.getters.getSubProfiles;
        },
        globalUserData() {
            return this.$store.getters.getGlobalUserData;
        }
    },
    methods: {
        resetData() {
            this.profileData = {
                name: '',
                age: 0,
                isPin: false,
                pin: null,
                soundPrompts: false,
                // facilitiesDysfunction: 'no',
                // facilitiesOptions: {
                //     audiodescription: false,
                //     autoSubtitling: false,
                //     signLanguage: false
                // },
                timeLimit: -1,
                sleepHours: [8, 19]
            }
        },
        goBack() {
            if(this.step > 1) {
                this.$store.dispatch("changeNewProfileStep", this.step - 1);

                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            } else {
                this.$router.go(-1);
            }
        },
        goNext() {
            if(this.step === 1) {
                if(!this.validationStep1()) {
                    return;
                }
            }
            if(this.step === 2) {
                if(!this.validationStep2()) {
                    return;
                }

                this.sendProfileData();
            }

            if(this.step < 3) {
                this.$store.dispatch("changeNewProfileStep", this.step + 1);

                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        },
        sendProfileData() {
            let data = {};          
            data = {
                "name": this.profileData.name,
                "age": this.profileData.age,
                "avatar": this.avatar.id,
                "pin": this.profileData.pin,
                "sound_prompts": false,
                // "audio_description": this.profileData.facilitiesOptions.audiodescription,
                // "subtitles_auto": this.profileData.facilitiesOptions.autoSubtitling,
                // "sign_language": this.profileData.facilitiesOptions.signLanguage,
                "play_from": this.getHour(this.profileData.sleepHours[0]),
                "play_to": this.getHour(this.profileData.sleepHours[1]),
                "time_limit": this.profileData.timeLimit,
                "set_pin": this.profileData.isPin === 'yes' ? true : false
            }

            axios
                .post(this.ADD_SUBPROFILE, data)
                .then(() => {
                    this.subAccountCreate(this.subProfileslist.length + 1, data.age);
                    this.$store.dispatch("subProfiles");
                })
                .catch(function() {
                    toast.error("Nie udało się zapisać profilu"); 
                });
        },
        setAge(age) {
            this.profileData.age = age;
            this.errors.age = '';

            if(age < 7) {
                this.profileData.isPin = false;
            }
        },
        // setCheckboxValue(value) {
        //     this.profileData.soundPrompts = value;
        // },
        setName(value) {
            this.profileData.name = value;
        },
        selectTimeLimit(value) {
            this.profileData.timeLimit = parseInt(value);
            this.errors.timeLimit = '';
        },
        selectSleepHours(value) {
            this.profileData.sleepHours = value;
        },
        // setFacilities(fD, fO) {
        //     this.profileData.facilitiesDysfunction = fD;

        //     if(fD === 'no') {
        //         this.profileData.facilitiesOptions = {
        //             audiodescription: false,
        //             autoSubtitling: false,
        //             signLanguage: false
        //         }
        //     } else {
        //         this.profileData.facilitiesOptions = fO;
        //     }
        // },
        closeModal() {
            this.isAvatarList = false;
            this.$store.dispatch("changeModalBackdrop", false);  
        },
        showAvatarList() {
            this.isAvatarList = true;
            this.$store.dispatch("changeModalBackdrop", true);  
        },
        savePin(pin) {
            this.profileData.pin = pin;
        },
        setIsPin(isPin) {
            this.profileData.isPin = isPin;
            if(isPin === 'no') {
                this.profileData.pin = null;
            }
        },
        scrollToError() {
            setTimeout(function() {
                const firstErr = document.querySelector(
                    '.error'
                );

                if (firstErr) {
                    const elToScroll = firstErr.parentElement;
                    const startPos = window.pageYOffset;
                    const diff = elToScroll.getBoundingClientRect().top;

                    window.scrollTo({
                        top: startPos + diff - 100,
                        behavior: 'smooth'
                    });
                 }
            }, 200);
        },
        validationStep1() {
            let validate = true;

            if(this.profileData.name.length < 3 ) {
                if(this.profileData.name.length > 0) {
                    toast.error("Imię jest zbyt krótkie"); 
                    this.errors.name = true;
                    validate = false;
                } else {
                    toast.error("Podaj imię dziecka"); 
                    this.errors.name = true;
                    validate = false;
                }
            } else if (!/^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ]+$/.test(this.profileData.name)) {
                toast.error("Imię może zawierać tylko litery"); 
                this.errors.name = true;
                validate = false;
            } else {
                this.errors.name = false;
            }
            if(this.profileData.age < 3) {
                toast.error("Podaj wiek dziecka"); 
                this.errors.age = true;
                validate = false;
            } else {
                this.errors.age = false;
            }

            if(this.profileData.isPin === 'yes') {
                if(!this.profileData.pin || this.profileData.pin.length !== 4) {
                    toast.error("PIN musi się składać z 4 cyfr"); 
                    this.errors.pin = true;
                    validate = false;
                } else {
                    this.errors.pin = false;
                }
            } else {
                this.errors.pin = false;
            }

            if(!this.avatar || !this.avatar.id) {
                validate = false;
            }

            if(validate === false) {
                this.scrollToError();
            }

            return validate;
        },
        validationStep2() {
            let validate = true;

            if(this.profileData.timeLimit === -1) {
                toast.error("Ustaw limit czasu"); 
                this.errors.timeLimit = true;
                validate = false;
            } else {
                this.errors.timeLimit = false;
            }

            if(this.profileData.sleepHours[1] > 24) {
                toast.error("Ustaw odpowiedni zakres godzin"); 
                this.errors.sleepHours = true;
                validate = false;
            } else {
                this.errors.sleepHours = false;
            }

            if(validate === false) {
                this.scrollToError();
            }

            return validate;
        },
        getHour(hour) {
            if(hour === 24) {
                return '23:59';
            } else {
                if(hour.toString().length < 2) {
                    return `0${Math.floor(hour)}:00`;
                }                
                return `${Math.floor(hour)}:00`;
            }
        },  
        consentHandle(value) {
            this.isModalConsent = false;

            if(value) {
                this.saveConsentAllow();

                if(this.globalUserData && this.globalUserData.has_pin === false) {
                    this.isModalPin = true;
                } else {
                    this.showAvatarList();
                }
            }  else {
                this.$store.dispatch("changeModalBackdrop", false);
            }
        },
        saveConsentAllow() {
            axios
                .post(this.CONSENT_ALLOW)
                .then((response) => {
                    if(response.data.data.success) {
                        toast.success("Zgody zostały zapisane"); 
                        this.$store.dispatch('globalUserData');
                    } else {
                        toast.error("Nie udało się zapisać zgód");
                    }
                })
                .catch(() => {
                    toast.error("Nie udało się zapisać zgód");
                }); 
        },
        modalPinToggle(pin) {
            this.isModalPin = false;
            if(pin) {
                this.showAvatarList();
            } else {
                this.$store.dispatch("changeModalBackdrop", false);
            }
        },             
    },
    mounted() {
        setTimeout(()=> {
            if (this.globalUserData && !this.globalUserData.subprofile_process_consent) {
                this.isModalConsent = true;
                this.$store.dispatch("changeModalBackdrop", true);
            } else if (this.globalUserData && this.globalUserData.has_pin === false) {
                this.isModalPin = true;
                this.$store.dispatch("changeModalBackdrop", true);
            } else if (!this.avatar || !this.avatar.id) {
                this.showAvatarList();
            }
        }, 400); 
    }
};
</script>